import React from 'react'
import './contactinfo.css'
import { PageIntro, GetInvolvedMsg } from '../Templates'


const ContactInfo = () => {
    return (
        <React.Fragment>
            <h1>Contact Info</h1>
            <PageIntro>We are stronger together! We’re looking forward to working with you.</PageIntro>

            <section className='content-box'>
                <GetInvolvedMsg />
                <br />
                <p className="text_container">Email: <a href="mailto:olivetreesolidarity@protonmail.com">olivetreesolidarity@protonmail.com</a></p>
                {/* <p>Email: <a href="mailto:FreePalestine@olivetreesolidarity.com">FreePalestine@olivetreesolidarity.com</a></p> */}
                <br />
                <p className="text_container">Instagram: <a href="https://www.instagram.com/olivetreesolidarity_/">@olivetreesolidarity</a></p>
            </section>
        </React.Fragment>
    )
}

export default ContactInfo;